import React, { useMemo, useRef, useState } from 'react';
import { anime } from 'react-anime';

import BaseSlider from 'components/sliders/BaseSlider';

import { InteractivePropType } from 'propTypes/common';

import ExhibitsPreview from './components/ExhibitsPreview';
// eslint-disable-next-line import/no-cycle
import ExhibitsSlide from './components/ExhibitsSlide';

import styles from './styles.module.scss';

const getOffsetElement = (element) => {
	const elementRect = element.getBoundingClientRect();
	const windowScrollTop = window.pageYOffset;
	const emptySpaceReserve = 80;
	const resultOffset = elementRect.top + windowScrollTop - emptySpaceReserve;

	return Math.round(resultOffset);
};

const Exhibits = ({ interactive }) => {
	const { exhibits } = interactive;
	const [sliderPreviewActive, setSliderPreviweActive] = useState(0);
	const refExhibits = useRef(null);

	const sliderParams = useMemo(
		() => ({
			slidesPerView: 1,
			spaceBetween: 8
		}),
		[]
	);

	const onClickPreview = (event) => {
		const slideIndex = parseInt(event.currentTarget.dataset.index, 10);
		const scrollElement =
			window.document.scrollingElement ||
			window.document.documentElement ||
			window.document.body;

		setSliderPreviweActive(slideIndex);

		anime({
			targets: scrollElement,
			scrollTop: getOffsetElement(refExhibits.current),
			duration: 500,
			easing: 'easeInOutQuad'
		});
	};

	return exhibits?.length ? (
		<div className={styles.Exhibits} ref={refExhibits}>
			<div className={styles.Exhibits__Main}>
				<BaseSlider
					params={sliderParams}
					slideToNumber={sliderPreviewActive}
					theme="exhibits"
					slideHeight="fill"
				>
					{exhibits.map((exhibit) =>
						exhibit?.file ? (
							<ExhibitsSlide
								exhibit={exhibit}
								key={`slide-${exhibit.file._id}`}
							/>
						) : null
					)}
				</BaseSlider>
			</div>
			<div className={styles.Exhibits__Nav}>
				{exhibits.map((exhibit, index) =>
					exhibit?.file ? (
						<ExhibitsPreview
							file={exhibit.file}
							key={`preview-${exhibit.file._id}`}
							index={index}
							isActive={index === sliderPreviewActive}
							onClick={onClickPreview}
						/>
					) : null
				)}
			</div>
		</div>
	) : null;
};

Exhibits.propTypes = {
	interactive: InteractivePropType
};

export default Exhibits;
